import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { finalCta } from "../../data/homeData";

function FinalCtaSection() {
  return (
    <section id="final-cta" className="relative mt-20 md:mt-24">
      <div className="w-full relative overflow-hidden bg-midnight-navy px-6 py-24 md:py-32">
        <div className="absolute inset-0 bg-gradient-to-br from-royal-blue/20 via-midnight-navy to-midnight-navy" />
        <div className="absolute right-0 top-0 h-[500px] w-[500px] rounded-full bg-royal-blue/20 blur-[120px]" />
        <div className="absolute left-0 bottom-0 h-[400px] w-[400px] rounded-full bg-warm-gold/10 blur-[100px]" />
        
        <div className="absolute inset-0 hero-grid opacity-10 pointer-events-none" />

        <div className="relative mx-auto w-full max-w-4xl text-center">
          <h2 className="text-2xl font-bold tracking-tight text-soft-white sm:text-3xl md:text-5xl lg:text-6xl">
            {finalCta.title}
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-sky-glow/85 sm:text-base md:text-lg">
            {finalCta.subtitle}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row flex-wrap justify-center gap-4">
            <Link
              to={finalCta.primary.to}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-soft-white px-8 py-4 text-sm font-bold text-midnight-navy shadow-[0_0_20px_rgba(255,255,255,0.2)] transition-all hover:bg-white hover:scale-105 hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] sm:text-base"
            >
              {finalCta.primary.label}
              <ArrowRight className="h-5 w-5" aria-hidden="true" />
            </Link>

            <a
              href={finalCta.secondary.to}
              className="inline-flex items-center justify-center rounded-xl border border-white/20 bg-white/5 px-8 py-4 text-sm font-bold text-soft-white backdrop-blur-md transition-all hover:bg-white/10 hover:border-white/40 sm:text-base"
            >
              {finalCta.secondary.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FinalCtaSection;
